import React from 'react';
import Slider from "@ant-design/react-slick";
import styled from '@emotion/styled';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { COLOR_MAP } from '../../constants/ColorNames';

type ScrollerProps = {
 children: React.ReactNode[] | null;
 settings? : any
}

const ScrollerWrapper = styled.div`
`

const StyledSlider = styled(Slider)`
.slick-dots li {
  width: 1rem;
}
.slick-dots li button:before{
    font-size: 2rem;
    color: ${COLOR_MAP.BORDER_GREY};
    opacity: 1;
  }
.slick-dots li.slick-active button:before {
  color: ${COLOR_MAP.BLACK}
}
`

const defaultSettings = {
  dots: true,
  infinite: true, // Use `infinite` instead of `loop`
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 1300
};

const Scroller = ( { children, settings = defaultSettings } :ScrollerProps ) => {
  return (
      <StyledSlider {...settings}>
        {children}
      </StyledSlider>
  )
}

export default Scroller